import { useContext } from 'react';

import { CandidateContext } from 'contexts';

export const useCandidateContext = () => useContext(CandidateContext);
